/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintVersionResource } from "./ConstraintVersionResource";
export const ConstraintVersionsResponse = core.serialization.object({
    data: core.serialization.list(ConstraintVersionResource),
});
